export default "__VITE_ASSET__DUq4fXvh__"